import { TriageDetails, User } from "../types";
import { OVERVIEW_TAB } from "../app/appConstants";

export type State = {
  authentication: {
    isFetching: boolean;
    loginFailed: boolean;
    isAuthenticated: boolean;
    user: User;
    failureMessage: string;
    lockOutDuration: number;
    isLoggingOut: boolean;
    logoutFailureMessage: string;
    lockedOutMessage: string;
    sessionTotalLength: number;
    sessionExpiry: string;
    initiatePasswordChange: boolean;
    accessToken: string;
    refreshToken: string;
    authenticatedWithKeycloak: boolean;
  };
  data: {
    rowData: [];
    tasks: [];
    projectPlan: [];
    invoices: [];
    attachments: [];
    triageDetails: TriageDetails;
  };
  details: {
    selectedTab: typeof OVERVIEW_TAB;
  };
};

export const initialState = {
  authentication: {
    isFetching: false,
    loginFailed: false,
    isAuthenticated: false,
    user: { username: null },
    failureMessage: null,
    lockOutDuration: 0,
    isLoggingOut: false,
    logoutFailureMessage: null,
    lockedOutMessage: null,
    /* The total length of a session (not the time remaining) as per the setting used on the backend. This is the basis
       from which client side sessions will be extended by. */
    sessionTotalLength: 900000,
    /* The actual expiry date-time of the client's session. */
    sessionExpiry: null,
    initiatePasswordChange: false,
    accessToken: null,
    refreshToken: null,
    authenticatedWithKeycloak: false,
  },
  data: {
    rowData: [],
    tasks: [],
    projectPlan: [],
    invoices: [],
    attachments: [],
    triageDetails: null,
  },
  details: {
    selectedTab: OVERVIEW_TAB,
  },
};
